import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import moment from 'moment';
import styled from 'styled-components';

import DatePicker from 'react-datepicker';
import Picker from 'antd-mobile/es/picker';
import enUS from 'antd/es/locale-provider/en_US';
import frFR from 'antd/es/locale-provider/fr_FR';
import nlNL from 'antd/es/locale-provider/nl_NL';
import LocaleProvider from 'antd-mobile/es/locale-provider';
import { MobileDatePicker } from 'components/ui/MobileDatePicker';
import { getTranslatedString, getCurrentLocale } from 'helpers/i18n';
import 'react-datepicker/dist/react-datepicker.css';
import { registerLocale } from 'react-datepicker';
import fr from 'date-fns/locale/fr';
import MediaQuery from 'react-responsive';
import { List } from 'antd';

const antLocalize = (locale) => {
  let result;

  switch (locale) {
    case 'en':
      result = enUS;
      break;
    case 'fr':
      result = frFR;
      break;
    case 'nl':
      result = nlNL;
      break;
    default:
      result = enUS;
  }
  return result;
};

const StyledListItem = styled(List.Item)`
  background: white;
  padding: 18.5px 14px;
  border-radius: 8px;
  border: rgba(0, 0, 0, 0.23) 1px solid;
  height: 55px;
  text-align: left;
  line-height: 16.625px;
  font-weight: 300;
  font-size: 16px;

  ${({ active }) =>
    active &&
    `
     color: #c5c5c5 !important;
  `};
`;

const DatePickerWrapper = styled.div`
  input {
    padding: 14px !important;
  }
`;

const floatingLabelStyle = {
  transform: 'translate(14px, -6px) scale(0.75)',
  background: 'white',
  width: 'auto',
  textAlign: 'initial',
  fontSize: '13px',
  marginLeft: '15px',
  position: 'absolute',
  top: '-4px',
  left: '-10px',
  zIndex: 1,
  paddingLeft: '5px',
  paddingRight: '5px',
};

class renderDatePicker extends React.Component {
  static propTypes = {
    input: PropTypes.shape({
      onChange: PropTypes.func,
      value: PropTypes.string,
    }).isRequired,
    meta: PropTypes.shape({
      touched: PropTypes.bool,
      error: PropTypes.string,
    }).isRequired,
    inputValueFormat: PropTypes.string,
  };

  static defaultProps = {
    inputValueFormat: null,
  };

  state = {
    selectedDate: null,
    datePickerlanguage: 'en',
    specificDatePickerValue: null,
  };

  componentWillMount() {
    if (this.props.input.value) {
      this.setState({
        selectedDate: moment(this.props.input.value, this.props.inputValueFormat).toDate(),
      });
    }
    if (this.props.currentLanguage === 'fr') {
      registerLocale('fr', fr);
      this.setState({
        datePickerlanguage: 'fr',
      });
    }
  }

  handleChange = (date) => {
    this.setState({
      selectedDate: date,
    });

    this.props.input.onChange(date, this.props.index);
  };

  handleSpecificDateChange = (value) => {
    this.setState({ specificDatePickerValue: value });

    const formattedDate = new Date(value[0], value[1] - 1, value[2]);

    this.props.input.onChange(formattedDate, this.props.index);
  };

  render() {
    const {
      label,
      meta: { touched, error },
      dateMode,
      ...rest
    } = this.props;

    return (
      <div>
        <MediaQuery query="(max-device-width: 750px)">
          <label style={floatingLabelStyle} aria-label={label}>
            {label}
          </label>
          <LocaleProvider locale={antLocalize(getCurrentLocale())}>
            {this.props.specificDatePickerMobile ? (
              <Picker
                name={this.props.name}
                data={this.props.customDates}
                value={this.state.specificDatePickerValue}
                format={(labels) => labels.join('-')}
                extra="e.g. 2019-01-01"
                onChange={this.handleSpecificDateChange}
                locale={{
                  okText: getTranslatedString('datePicker.ok'),
                  dismissText: getTranslatedString('datePicker.cancel'),
                }}
              >
                <StyledListItem active={!this.state.specificDatePickerValue} arrow="horizontal" />
              </Picker>
            ) : (
              <MobileDatePicker
                {...rest}
                minDate={this.props.minDate || new Date(1910, 1, 1, 0, 0, 0)}
                value={this.state.selectedDate}
                mode={dateMode ? dateMode : 'date'}
                extra={dateMode === 'month' ? 'e.g. 2019-01' : 'e.g. 2019-01-01'}
                onChange={this.handleChange}
                locale={{
                  okText: getTranslatedString('datePicker.ok'),
                  dismissText: getTranslatedString('datePicker.cancel'),
                }}
              >
                <StyledListItem active={!this.state.selectedDate} arrow="horizontal" />
              </MobileDatePicker>
            )}
          </LocaleProvider>
        </MediaQuery>
        <MediaQuery query="(min-device-width: 750px)">
          <label style={floatingLabelStyle} aria-label={label}>
            {label}
          </label>
          <DatePickerWrapper>
            <DatePicker
              {...rest}
              locale={this.state.datePickerlanguage}
              selected={this.state.selectedDate}
              onChange={this.handleChange}
            />
          </DatePickerWrapper>
        </MediaQuery>
        {touched && error && (
          <div style={{ color: 'red', fontSize: '12px', marginLeft: '12px', marginTop: '4px' }}>
            {error}
          </div>
        )}
      </div>
    );
  }
}

renderDatePicker = connect((state) => ({
  currentLanguage: state.locale.currentLanguage,
}))(renderDatePicker);

export default renderDatePicker;
